import { memo } from 'react'

import styled from 'styled-components'

import { SyntaxHighlighter as DefaultSyntaxHighlighter } from 'components/SyntaxHighlighter'

export const SyntaxHighlighter = styled(memo(DefaultSyntaxHighlighter))`
	padding: 0 0 2px;

	pre {
		overflow: scroll !important;
		max-height: calc(100vh - 225px);
		border: none !important;

		@media only screen and (max-width: 1250px) {
			max-height: unset;
		}
	}
`
